import Api from "@/service/api";

// // 获取所有订单
// export async function getAllOrders(options?: { [key: string]: any }) {
//   return Api.request({
//     url: "/askpaul/orders",
//     method: "GET",
//     params:{...options}
//   });
// }

// // 获取订单详情
// export async function getOrderDetail(options?: { [key: string]: any }) {
//   return Api.request({
//     url: "/askpaul/order/"+options?.orderId,
//     method: "GET",
//   });
// }

export async function chatList<T>() {
  return Api.request<T>({
    url: "/assistant/chat_list",
    method: "GET"
  });
}

export async function chatMsgList<T>(id: string | number) {
  return Api.request<T>({
    url: "/assistant/chat_msg_list/" + id,
    method: "GET"
  });
}

export async function assistantChat<T>(data: { message: string, chat_id?: string, relation_type?: string, relation_id?: string }) {
  if (data.chat_id === "null") {
    delete data.chat_id;
  }
  if (data.relation_type === "null") {
    delete data.relation_type;
  }
  if (data.relation_id === "null") {
    delete data.relation_id;
  }
  return Api.request<T>({
    url: "/assistant/chat",
    data,
    method: "POST"
  });
}

export async function askpaulChat<T>(data: { message: string }) {
  return Api.request<T>({
    url: "/askpaul/chat",
    data,
    method: "POST"
  });
}

export async function welcome<T>(data: { chat_id?: string, relation_type?: string, relation_id?: string, data?: string }) {
  if (data.chat_id === "null") {
    delete data.chat_id;
  }
  if (data.relation_type === "null") {
    delete data.relation_type;
  }
  if (data.relation_id === "null") {
    delete data.relation_id;
  }
  return Api.request<T>({
    url: "/assistant/welcome",
    data,
    method: "POST"
  });
}

export async function deleteOrdersByEventId<T>(id: string) {
  return Api.request<T>({
    url: "/assistant/chat/" + id,
    method: "DELETE"
  });
}
